import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Check, TreePine } from "lucide-react";
import { useI18n } from "../i18n/LanguageContext";
import { demoCopy } from "../i18n/demoCopy";
import { MEDIA, srcSet } from "../lib/media";
import SnowLayer from "../components/SnowLayer";
import { StarField } from "../components/Cinematic";
import { Modal } from "../components/Modal";
import { useDemoBuy } from "./useDemoBuy";
import { demoTrack, exitDemo, endDemo, visitedAreas, AREAS, setInsideDemo } from "./demoMode";

export default function DemoEnd() {
  setInsideDemo(false);
  const { lang, t } = useI18n();
  const C = demoCopy(lang);
  const navigate = useNavigate();
  const { buy, current, showSoon, setShowSoon } = useDemoBuy();
  useEffect(() => { endDemo(); demoTrack("end_view", { areas: visitedAreas().length, total: AREAS.length }); }, []);
  const back = () => { demoTrack("exit", { from: "end" }); exitDemo(); navigate("/"); };
  return (
    <div className="relative flex min-h-screen items-center justify-center overflow-hidden bg-xmas-navy px-4 py-16 text-xmas-snow" data-testid="demo-end">
      <img src={MEDIA.familyHome} srcSet={srcSet(MEDIA.familyHome)} sizes="100vw" alt="" className="absolute inset-0 h-full w-full object-cover opacity-40" />
      <div className="absolute inset-0 bg-gradient-to-b from-xmas-navy/80 via-xmas-navy/85 to-xmas-navy" />
      <StarField count={50} /><SnowLayer />
      <div className="relative z-10 w-full max-w-2xl rounded-[2rem] border border-xmas-gold/25 bg-xmas-navy/70 p-7 text-center shadow-2xl backdrop-blur-xl sm:p-12 float-up">
        <TreePine className="mx-auto h-10 w-10 text-xmas-gold" />
        <p className="mt-3 text-[11px] uppercase tracking-[0.3em] text-xmas-gold/85">{C.end.ended}</p>
        <h1 className="mt-3 font-display text-3xl font-black uppercase leading-[1.05] text-xmas-gold sm:text-4xl lg:text-5xl" data-testid="demo-end-title">{C.end.t}</h1>
        <p className="mx-auto mt-5 max-w-xl text-base text-xmas-champagne md:text-lg">{C.end.sub}</p>
        <ul className="mx-auto mt-8 grid max-w-lg grid-cols-2 gap-x-6 gap-y-2.5 text-left text-sm">
          {C.end.benefits.map((b) => <li key={b} className="flex items-center gap-2"><Check className="h-4 w-4 shrink-0 text-xmas-gold" /> {b}</li>)}
        </ul>
        <button onClick={() => buy("end")} data-testid="demo-end-cta" className="btn-gold mt-9 w-full rounded-full px-10 py-4 text-sm font-bold uppercase tracking-wider sm:w-auto">{C.end.cta}{current?.display ? ` — ${current.display}` : ""}</button>
        <div><button onClick={back} data-testid="demo-end-back" className="mt-4 rounded-full border border-xmas-gold/30 px-6 py-3 text-xs font-semibold uppercase tracking-wider text-xmas-champagne transition hover:border-xmas-gold hover:text-xmas-gold">{C.end.back}</button></div>
      </div>
      <Modal open={showSoon} onClose={() => setShowSoon(false)} title={t("checkout.soon_title")} testid="demo-checkout-soon"><p className="text-sm text-xmas-slate">{t("checkout.soon")}</p></Modal>
    </div>
  );
}
